<template>
	<div class="layout-menu-container">
		<AppSubmenu :permissions="permissions" :items="model" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" />
	</div>
</template>

<script>
import AppSubmenu from './SubmenuRoot';

export default {
	props: {
		model: Array,
		permissions: Array
	},
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        }
    },
	components: {
		'AppSubmenu': AppSubmenu
	}
}
</script>

<style scoped>

</style>